// extracted by mini-css-extract-plugin
export default {"link":"styles_link__0ilLi","button":"styles_button__XENLV"};